import { render, staticRenderFns } from "./ModalDetailComponent.vue?vue&type=template&id=7f216720&scoped=true"
import script from "./ModalDetailComponent.vue?vue&type=script&lang=js"
export * from "./ModalDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalDetailComponent.vue?vue&type=style&index=0&id=7f216720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f216720",
  null
  
)

export default component.exports